import type { CaseProgramUpsert, CaseView } from "shared";
import { api } from "./api";

export type CaseProgram = {
  programId: string; slug?: string; name?: string; stateCode: string | null;
  status: CaseProgramUpsert["status"]; note: string; updatedAt: string;
};
export type CaseNote = { id: string; caseId: string; userId: string; authorName?: string; body: string; createdAt: string; updatedAt: string };
export type Followup = { id: string; caseId: string; userId: string; dueAt: string; note: string; doneAt: string | null; caseTitle?: string };
export type Interaction = { id: string; caseId: string; kind: string; direction: string; summary: string; createdAt: string };
export type CaseDetail = { case: CaseView; notes: CaseNote[]; programs: CaseProgram[]; followups: Followup[]; interactions: Interaction[] };

export const caseKey = (id: string) => ["case", id] as const;

export const STATUS_LABELS: Record<CaseProgram["status"], string> = {
  recommended: "Recommended", referred: "Referred", applied: "Applied", approved: "Approved", denied: "Denied", withdrawn: "Withdrawn",
};
/** What the customer tells us; the agency's real decision is not known to the portal. */
export const CUSTOMER_REPORTED = new Set<CaseProgram["status"]>(["applied", "approved", "denied", "withdrawn"]);

/**
 * Sets a program's status on a case. The server resets status and state when either is missing, so both are always
 * sent, together with the note already on file.
 */
export function putProgram(caseId: string, existing: CaseProgram | undefined, programId: string, status: CaseProgram["status"], fallbackState: string | null) {
  return api(`/api/cases/${caseId}/programs/${programId}`, {
    method: "PUT",
    body: { status, stateCode: existing?.stateCode ?? fallbackState, note: existing?.note ?? "" },
  });
}
